import $http from '../../../axios-instance';
import Swal from 'sweetalert2';


/**
 * Registrar un adjunto.
 * @param payload:
 * @returns {Promise} Adjunto creada
 * @autor Paul Valencia
 */
export async function createEtProductAttachemt({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post('et_product_attachment/create', payload);
        return Promise.resolve(response.data.data);
    } catch (error) {
        const htmlErrors = window.listErrors(error);
        commit('dashboard/load', false, {root: true});
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: htmlErrors,
            showConfirmButton: false,
            timer: 2000
        });
        return Promise.reject(error);
    } finally {
        commit('dashboard/load', false, {root: true});
    }

}

/**
 * Devuelve los adjuntos de un producto por compañia.
 * @param state.filter: company_id, product_id
 * @returns {Promise} lista de adjuntos
 * @autor Paul Valencia
 */
export async function getAttachmentByProduct({commit, state}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('et_products_attachment', {params: state.filter}).then(async (response) => {
        commit('dashboard/load', false, {root: true});
        commit('setAttachments', response.data)
    }).catch(async (error) => {
        commit('dashboard/load', false, {root: true});
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    });

}


/**
 * Actualizar un adjunto.
 * @param payload: id, et_product_id, language_id, type, date_expiration, file?, comment?
 * @returns {Promise} adjunto actualizado
 * @autor Paul Valencia
 */
export async function updateAttachment({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post(`et_product_attachment/${payload.get('id')}/update`, payload);
        commit('updateAdjunto', response.data.data)
        return Promise.resolve(response.data);
    } catch (error) {
        if (error.errors) {

            let htmlErrors = '<ul style="margin-bottom: 0rem">';
            const errorMessages = Object.values(error.errors);

            errorMessages[0].forEach(error => {
                htmlErrors += `<li>${error}</li>`
            })

            htmlErrors += '</ul>'

            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: htmlErrors,
                showConfirmButton: false,
                timer: 20000
            });
        } else {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 20000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }

}

/**
 * Cambiar el estado de un adjunto a inactivo para simular la eliminación.
 *
 * @param payload: id, company_id
 * @autor Paul Valencia
 * @returns company_id
 */
export async function deleteAdj(context, {id, company_id}) {

    await $http.patch(`et_product_attachment/${id}/delete`, {company_id}).then(async (response) => {
        await Swal.fire({
            position: 'center',
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 2000
        });

    }).catch(async (error) => {
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    });
}


/**
 * Descarga la imagen del adjunto.
 *
 * @param data: id, company_id
 * @autor Paul Valencia
 * @returns void
 */
export async function downloadFile({commit}, data) {
    commit('dashboard/load', true, {root: true});
    await $http({
        url: 'et_product_attachment_downloadFile',
        method: 'POST',
        responseType: 'blob',
        data
    }).then((response) => {
        commit('dashboard/load', false, {root: true});
        const file = data.file;
        window.downloadFile(response.data, file)
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message + '<br> ' + error.error,
            showConfirmButton: true,
            timer: 5000
        });
    });

}
